import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import type { BatchCosignBody, BatchCosignResponse } from "@/core/types";
import { cosignatureKeys } from "@/features/cosignature/api/keyFactory";
import { showToast } from "@/providers/ToastProvider";

import { batchCosignAction } from "../queryFunctions/batchCosignAction";

export function useBatchCosignDocuments({
  onSuccess,
  ...options
}: UseMutationOptions<BatchCosignResponse, unknown, BatchCosignBody> = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: batchCosignAction,
    ...options,
    onError: () => {
      showToast([{ heading: "Something went wrong. Please try again.", variant: "error" }]);
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: cosignatureKeys.base });
      onSuccess?.(data, variables, context);
      showToast([{ heading: "Notes approved and co-signed.", variant: "success" }, { delay: 500 }]);
    },
  });
}
